'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

var _pick = require('./pick');

var _pick2 = _interopRequireDefault(_pick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _prep2.default)({
    name: 'slice',
    immutable: 'slice',
    object: function object() {
        var begin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var end = arguments[1];
        return function (value) {
            var keys = Object.keys(value);
            var keysSliced = end || end === 0 ? keys.slice(begin, end) : keys.slice(begin);

            return (0, _pick2.default)(keysSliced)(value);
        };
    },
    array: function array() {
        var begin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var end = arguments[1];
        return function (value) {
            return end || end === 0 ? value.slice(begin, end) : value.slice(begin);
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/slice.js
// module id = 195
// module chunks = 35783957827783